@use "../../../config/defaults.module.scss" as defaults;

img.subscriptionLogo {
	@apply
	yst-inline-block
	yst-min-w-16
	yst-max-w-16
	yst-min-h-16
	yst-max-h-16
	yst-align-middle
	yst-opacity-40;

	&.hasSubscriptions {
		@apply yst-opacity-100;
	}
}

.subscriptionUsage {
	@apply
	yst-hidden;

	&.hasSubscriptions {
		@apply
		yst-flex
		yst-flex-col
		yst-items-center
		sm:yst-flex-row
		yst-gap-2;
	}
}

.provisionerSection {
	min-width: 152px;

	@media screen and (max-width: defaults.$mobileBreakpoint) {
		width: 100%;
		background-image: none;
		padding: 12px 16px;
	}
}

.manage {
	@apply yst-bg-green-500;
}

/*
 * The display overrides below sit in the `host-overrides` cascade layer
 * declared in src/index.css. That layer is the last in the order, so these
 * !important rules still win over the host's ui-library defaults — but they
 * now participate in the layered cascade, which lets a future second embedded
 * ui-library consumer be ordered against them deterministically (instead of
 * an unlayered `!important` arms race).
 */
@layer host-overrides {
	.column {
		display: none !important;

		&.isEnabled {
			display: inline-block !important;
		}

		&.fixed {
			display: flex !important;
		}
	}

	.row {
		@apply
		yst-flex-col
		sm:yst-flex-row
		yst-items-center
		yst-gap-4
		yst-p-4;

		display: flex !important;

		td {
			padding: 0 !important;
		}

		.firstColumn {
			@apply
			yst-w-full
			sm:yst-w-auto
			yst-flex-col
			sm:yst-flex-row
			yst-gap-3
			yst-items-center;

			display: flex !important;

			/*
			 * Placeholder for the toggle of a product that has not been purchased: it
			 * reserves the toggle's width so the product icons stay aligned, but only
			 * from `sm` up, where the column is horizontal. Below `sm` the column
			 * stacks, so the placeholder is collapsed instead of leaving a gap above
			 * the icon. No `!important` here — it would beat the `sm:` variant at
			 * every viewport.
			 */
			.hiddenToggle {
				@apply
				yst-hidden
				sm:yst-block;
			}
		}

		.secondColumn {
			@apply
			yst-flex-col
			yst-items-center
			sm:yst-items-start
			yst-gap-2;
			display: flex !important;
		}

		.thirdColumn {
			@apply
			sm:yst-ml-auto;

			display: none !important;

			&.isEnabled {
				display: flex !important;
			}
		}

		.fourthColumn {
			@apply
			yst-w-full
			sm:yst-w-auto
			yst-mt-2
			sm:yst-mt-0
			sm:yst-ml-auto;

			&.isEnabled {
				@apply sm:yst-ml-4;
			}

			button, a {
				@apply
				yst-w-full
				sm:yst-w-24;
			}
		}

		.subscriptionButton {
			svg {
				@apply
				yst-ml-2
				yst-h-5
				yst-w-5;
			}
		}
	}
}
